import { makeAutoObservable } from "mobx";
import { IdMap, RArray } from "../../collections";
import { OrderLineReference } from "../OrderLineReference";
import { ActivationState } from "./ActivationState";
export class ProductPromotionInstance {
    constructor(params) {
        this.kind = "Product";
        this.id = params.id;
        this.promotionType = params.promotionType;
        this._activationState = params.activationState;
        this._preExclusionState = null;
        this.discountSource = params.discountSource;
        this.discountTarget = params.discountTarget;
        this._freebie = params.freebie;
        this.excludedInstances = IdMap.empty();
        makeAutoObservable(this);
    }
    static fromStorageData(params) {
        const { promotionType, id, storageData, purchaseOrderPayload } = params;
        if (promotionType.scope.kind !== "Product") {
            return null;
        }
        const discountSource = storageData.discountSource.map((referenceStorageData) => OrderLineReference.fromStorageData({
            purchaseOrderPayload,
            storageData: referenceStorageData,
        }));
        if (!discountSource.every((el) => el !== null)) {
            return null;
        }
        const discountTarget = OrderLineReference.fromStorageData({
            purchaseOrderPayload,
            storageData: storageData.discountTarget,
        });
        if (discountTarget === null) {
            return null;
        }
        return new ProductPromotionInstance({
            id,
            promotionType,
            activationState: ActivationState.fromStorageData(storageData.active),
            discountSource: new RArray(discountSource),
            discountTarget,
            freebie: params.freebie,
        });
    }
    setExcludedInstances(excluded) {
        this.excludedInstances = excluded;
    }
    get active() {
        return ActivationState.isActive(this._activationState);
    }
    get activationState() {
        return this._activationState;
    }
    get preExclusionState() {
        return this._preExclusionState;
    }
    setActive(active) {
        this._activationState = active
            ? ActivationState.UserEnabled
            : ActivationState.UserDisabled;
        this._preExclusionState = null;
        if (active) {
            this.excludedInstances.objects.forEach((excludedInstance) => excludedInstance.deactivateByExclusion());
        }
        else {
            this.excludedInstances.objects.forEach((excludedInstance) => excludedInstance.reactivateByExclusion());
        }
    }
    deactivateByExclusion() {
        this._preExclusionState = this._activationState;
        this._activationState = ActivationState.SolverDisabled;
    }
    reactivateByExclusion() {
        if (this._preExclusionState !== null) {
            this._activationState = this._preExclusionState;
            this._preExclusionState = null;
        }
    }
    setActivationState(state) {
        this._activationState = state;
    }
    get freebie() {
        return this._freebie;
    }
    setFreebie(freebie) {
        this._freebie = freebie;
        this._activationState = "UserEnabled";
    }
    get storageData() {
        return {
            kind: "ProductPromotionInstance",
            promotionTypeId: this.promotionType.id.value,
            active: ActivationState.storageData(this._activationState),
            discountSource: this.discountSource.raw.map((discountSource) => discountSource.storageData),
            discountTarget: this.discountTarget.storageData,
            freebie: this.freebie === null ? null : this.freebie.storageData,
        };
    }
}
